/** Shared role helpers for post-login routing and nav menus. */

export const STAFF_ROLES = [
  'ROLE_SUPER_ADMIN',
  'ROLE_PLATFORM_MANAGER',
  'ROLE_SALON_OWNER',
  'ROLE_BRANCH_MANAGER',
  'ROLE_ACCOUNTANT',
  'ROLE_BARBER',
  'ROLE_RECEPTIONIST',
] as const

export function isStaffRoles(roles: string[] | undefined | null): boolean {
  if (!roles?.length) return false
  return STAFF_ROLES.some((role) => roles.includes(role))
}

/** Home path after login: staff → dashboard, customer → Mein Bereich. */
export function homePathForRoles(roles: string[]): string {
  if (roles.includes('ROLE_SUPER_ADMIN') || roles.includes('ROLE_PLATFORM_MANAGER')) return '/admin'
  if (roles.includes('ROLE_SALON_OWNER') || roles.includes('ROLE_BRANCH_MANAGER') || roles.includes('ROLE_ACCOUNTANT')) {
    return '/salon/dashboard'
  }
  if (roles.includes('ROLE_BARBER') || roles.includes('ROLE_RECEPTIONIST')) return '/employee'
  return '/account'
}

/** Safe internal redirect from ?next= — staff always go home; customers may follow next. */
export function resolvePostLoginPath(roles: string[], nextRaw: string | null): string {
  const home = homePathForRoles(roles)
  if (isStaffRoles(roles)) return home
  if (!nextRaw || !nextRaw.startsWith('/') || nextRaw.startsWith('//')) return home
  // Strip hash-only tricks; keep query (e.g. /book?resume=1)
  const pathOnly = nextRaw.split('#')[0] || nextRaw
  // Customers shouldn't land on staff dashboards via next=
  if (
    pathOnly.startsWith('/admin')
    || pathOnly.startsWith('/salon')
    || pathOnly.startsWith('/employee')
  ) {
    return home
  }
  return pathOnly
}
